import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlBatch,
  urlBatchSecured,
  urlGetAllBatchesSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_BATCH,
  GET_BATCH,
  UPDATE_BATCH,
  DELETE_BATCH,
  FILTER_BATCH,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterQueryAll = ({ filters }) => {
  let filter = "?";

  if (filters) {
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
  }

  return filter;
};

/**
 * Get Batch by uuid.
 */
export const getBatchByUuid = createAction(GET_BATCH, (param) =>
  apiGet(urlBatchSecured, param, true)()
);

/**
 * Filter list Batch.
 */
export const filterBatch = createAction(FILTER_BATCH, (filter, param) =>
  apiGet(urlBatchSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Batch.
 */
export const createBatch = createAction(CREATE_BATCH, (obj) =>
  apiPost(urlBatchSecured, obj, undefined, true)()
);

/**
 * Update Batch.
 */
export const modifyBatch = createAction(UPDATE_BATCH, (obj, param) =>
  apiPut(urlBatchSecured, obj, param, true)()
);

/**
 * Delete Batch by uuid.
 */
export const removeBatch = createAction(DELETE_BATCH, (param) =>
  apiDelete(urlBatchSecured, param, true)()
);

/**
 * Filter list locations.
 */
export const getAll = createAction("GET_ALL_BATCHES", (filters) =>
  apiGet(
    urlGetAllBatchesSecured + generateFilterQueryAll(filters),
    undefined,
    false
  )()
);
